import React from 'react';
import { Helmet } from 'react-helmet';
interface SEOProps {
  title?: string;
  description?: string;
  pathname?: string;
  children?: React.ReactNode;
}
export function SEO({
  title = 'Fight Club Med Spa Phoenix, Arizona',
  description = 'Premier medical aesthetics spa offering neuromodulators, fillers, PDO threads, and more. Retail location in Phoenix and traveling concierge services in Arizona and beyond.',
  pathname = '',
  children
}: SEOProps) {
  const siteUrl = 'https://fightclubmedspa.com';
  const canonical = pathname ? `${siteUrl}${pathname}` : siteUrl;
  return <Helmet data-id="element-391">
      {/* Basic Meta Tags */}
      <title data-id="element-392">{title}</title>
      <meta name="description" content={description} data-id="element-393" />
      <meta name="keywords" content="Med Spa Phoenix, Concierge Med Spa Phoenix, Aesthetics Phoenix, Botox Phoenix, Fillers, PDO Threads, Microneedling, Medical Aesthetics" data-id="element-394" />
      <link rel="canonical" href={canonical} data-id="element-395" />
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-396" />
      <meta property="og:url" content={canonical} data-id="element-397" />
      <meta property="og:title" content={title} data-id="element-398" />
      <meta property="og:description" content={description} data-id="element-399" />
      <meta property="og:image" content={`${siteUrl}/og-image.jpg`} data-id="element-400" />
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-401" />
      <meta name="twitter:url" content={canonical} data-id="element-402" />
      <meta name="twitter:title" content={title} data-id="element-403" />
      <meta name="twitter:description" content={description} data-id="element-404" />
      <meta name="twitter:image" content={`${siteUrl}/twitter-image.jpg`} data-id="element-405" />
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" data-id="element-406" />
      <meta name="googlebot" content="index, follow" data-id="element-407" />
      <meta name="geo.region" content="US-AZ" data-id="element-408" />
      <meta name="geo.placename" content="Phoenix" data-id="element-409" />
      {children}
    </Helmet>;
}